import * as d3 from 'd3'

export default {

  methods: {

    gmx_dateDiff(d1, d2) {
      const date1 = new Date(d1)
      const date2 = new Date(d2)
      const diffDate = date1.getTime() - date2.getTime()
      
      return (diffDate / (1000 * 60 * 60 * 24))
    },


    gmx_changeDate(format, str){
      let _year = null
      let _month = null
      let _day = null
      let result = null

      switch(format){
        case '/': 
          _month = Number(str.substr(5,2))
          _day = Number(str.substr(8,2))
          result = `${_month}/${_day}`
        break;
      }
      return result
    },


    gmx_addOneWeek(dateStr) {
      const date = new Date(dateStr)
      date.setDate(date.getDate() + 7)
      return date.toISOString().slice(0, 10)
    },

    
    gmx_getLastSameWeekdayOfNextMonth(dateStr) {
      const base = new Date(dateStr)
      const targetDay = base.getDay() +1 
      const lastDayOfNextMonth = new Date(base.getFullYear(), base.getMonth() + 2, 0)
      const diff = (lastDayOfNextMonth.getDay() - targetDay + 7) % 7

      lastDayOfNextMonth.setDate(lastDayOfNextMonth.getDate() - diff)
      return lastDayOfNextMonth.toISOString().slice(0, 10)
    },
    


  }
}
